/**
 * ScheduleReportOverlay Component
 *
 * Fullscreen overlay portal for the schedule report form.
 * Handles portal creation and animation with a simple fade + scale effect.
 */

import React from 'react';
import { FormOverlay } from '@/components/common/FormOverlay';
import { ScheduleReportForm } from './ScheduleReportForm';

export interface ScheduleReportOverlayProps {
  /** Whether the overlay is visible */
  isOpen: boolean;
  /** Workflow execution ID for the insight */
  workflowExecutionId: string;
  /** Insight preview blocks from behaviour action */
  blocks: unknown[];
  /** Default title from the behaviour action (user can override) */
  title?: string;
  /** Callback fired when the overlay is closed */
  onClose: () => void;
  /** Callback fired when the form is successfully submitted */
  onSuccess: () => void;
  /** Whether to animate towards the reports icon on close */
  animateTowardsIcon?: boolean;
}

export const ScheduleReportOverlay: React.FC<ScheduleReportOverlayProps> = ({
  isOpen,
  workflowExecutionId,
  blocks,
  title,
  onClose,
  onSuccess,
  animateTowardsIcon = false,
}) => {
  return (
    <FormOverlay
      isOpen={isOpen}
      onClose={onClose}
      animateTowardsSelector={animateTowardsIcon ? '[data-reports-icon]' : undefined}
    >
      <ScheduleReportForm
        workflowExecutionId={workflowExecutionId}
        blocks={blocks}
        title={title}
        onClose={onClose}
        onSuccess={onSuccess}
      />
    </FormOverlay>
  );
};

